import AutoComplete from "components/AutoComplete";
import TableOnly from "components/DataTable/TableOnly";
import Pagination from "components/Pagination/Pagination";
import SearchComp from "components/SearchComp/SearchComp";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import DeleteModalButton from "../../../../components/DeleteModalBtn/DeleteModalButton";
import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import FindReportAdvanceFormLayout from "./FindMaterial/FindReportAdvanceFormLayout";
import Table from "components/DataTable/Table";
import { parseFloatData } from "utils/UtilityFuncs";

let API_URL = "/manufacturer-material-lists";
let COMPONENT_URL = "/manufacturer/material-stock";
let COMPONENT_DETAILS_URL = "manufacturer/material-stock";

let filterBy = [
  {
    value: "materialId",
    name: "ID",
  },
  {
    value: "type",
    name: "Type",
  },
  {
    value: "styleId",
    name: "Style ID",
  },
  {
    value: "description",
    name: "Description",
  },
  {
    value: "gsm",
    name: "Gsm",
  },
  {
    value: "color",
    name: "Color",
  },
  {
    value: "minQty",
    name: "Min Qty",
  },
];

let limits = [5, 10, 15, 20];

export default function MaterialList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  /*   All States
   ********************************************* */
  const [materialListData, setMaterialListData] = useState([]);
  const [searchResults, setSearchResults] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  const [advanceSearchModal, setAdvanceSearchModal] = useState(false);
  const [advanceSearchResult, setAdvanceSearchResult] = useState(false);

  const [totalPages, setTotalPages] = useState(
    parseInt(searchParams.get("totalPages")) || 1,
  );
  if (searchParams.get("limit") === null) {
    setSearchParams((prev) => {
      let limit = searchParams.get("limit") || "10";
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", limit);
      return newParams.toString();
    });
  }
  if (searchParams.get("material-page") === null) {
    setSearchParams((prev) => {
      let page = searchParams.get("material-page") || "1";
      const newParams = new URLSearchParams(prev);
      newParams.set("material-page", page);
      return newParams.toString();
    });
  }
  if (searchParams.get("filterBy") === null) {
    setSearchParams((prev) => {
      let filterBy = searchParams.get("filterBy") || "all";
      const newParams = new URLSearchParams(prev);
      newParams.set("filterBy", filterBy);
      return newParams.toString();
    });
  }

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */

  const changeLimit = (val) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", val);
      return newParams.toString();
    });
  };

  const handleFilterBy = (filter) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("filterBy", filter);
      return newParams.toString();
    });
  };

  const getMaterialLists = async () => {
    try {
      setLoading(true);

      let page = parseInt(searchParams.get("material-page")) || 1;
      let limit = parseInt(searchParams.get("limit")) || 10;
      let query = searchParams.get("query") || "";
      let filterBy = searchParams.get("filterBy") || "all";

      let body = { page, limit, filterBy };

      // check for sort and order in searchParams
      let sort = searchParams.get("sort");
      let order = searchParams.get("order");
      if (sort && order) {
        body.sort = sort;
        body.order = order;
      }

      if (query) {
        body.query = query;
      }

      const { data } = await API.post(API_URL, body, {
        headers: authHeader(),
      });
      if (data.success) {
        setMaterialListData(data.data);
        setTotalPages(data.totalPages);
        setSearchResults(null);
        return data.data;
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          }),
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  // AutoComplete Search Function
  const searchMaterialList = async (searchText, fieldName) => {
    try {
      setLoading(true);

      const { data } = await API.post(
        "/manufacturer-material-list/auto-complete",
        { searchText, fieldName },
        {
          headers: authHeader(),
        },
      );
      if (data?.success) {
        return data?.data;
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          }),
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  // Delete
  const deleteMaterialListData = async (id) => {
    try {
      setLoading(true);
      const { data } = await API.delete("/manufacturer-material-list/" + id, {
        headers: authHeader(),
      });
      if (data?.success) {
        setMaterialListData((prev) => prev.filter((item) => item.id !== id));
        dispatch(
          setNotification({
            message: data?.message,
            type: "success",
          }),
        );
        return;
      }
      dispatch(
        setNotification({
          message: data?.message,
          type: "error",
        }),
      );
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    } finally {
      reset();
    }
  };

  // Adds Button Function
  const handleMaterialListData = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.post("/manufacturer-material-list", formData, {
        headers: authHeader(),
      });
      if (data?.success) {
        setMaterialListData((prev) => [...prev, data?.data]);
        setFormData({});
        setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          }),
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    } finally {
      reset();
    }

    setShowAddModal(false);
  };

  // Update Button Function
  const handleUpdateMaterialListData = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.patch(
        "/manufacturer-material-list/",
        formData,
        {
          headers: authHeader(),
        },
      );
      if (data?.success) {
        setMaterialListData((prev) => {
          const newData = prev.map((item) => {
            if (item.id === formData.id) {
              return data?.data;
            }
            return item;
          });
          return newData;
        });
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          }),
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    } finally {
      reset();
    }
  };

  const handleUpdateData = async (item) => {
    setFormData(item);
    setIsUpdateMode(true);
    setShowAddModal(true);
  };

  const reset = () => {
    setFormData({});
    setLoading(false);
    setIsUpdateMode(false);
    setShowAddModal(false);
  };

  const handleAutoCompleteChange = (key, value) => {
    setFormData((prev) => {
      return { ...prev, [key]: value };
    });
  };

  const getSearchParamsWithoutGivenKey = (key) => {
    let params = new URLSearchParams(searchParams);
    params.delete(key);
    return params.toString();
  };

  /*   All UseEffects
   ********************************************* */

  useEffect(() => {
    let timeout = setTimeout(() => {
      let _filterBy = searchParams.get("filterBy") || "all";
      let _query = searchParams.get("query") || "";
      if (_filterBy && _filterBy !== "all" && !_query) {
        return;
      }
      getMaterialLists();
    }, 50);
    return () => clearTimeout(timeout);
  }, [searchParams]);

  /*   Table Functions
   ********************************************* */
  const table_head = [
    { name: "ID", value: "materialId" },
    { name: "Type", value: "type" },
    { name: "Style ID", value: "styleId" },
    { name: "Description", value: "description" },
    { name: "GSM", value: "gsm" },
    { name: "Color", value: "color" },
    { name: "Available Qty", value: "availableQty" },
    { name: "Actions", value: "Actions" },
  ];

  const advanceTableHead = [
    "ID",
    "Type",
    "Style ID",
    "Description",
    "GSM",
    "Color",
    "Min Qty",
    "Actions",
  ];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="py-1 align-middle">{item?.materialId}</td>
      <td className="py-1 align-middle">{item?.type}</td>
      <td className="py-1 align-middle">{item?.styleId}</td>
      <td className="py-1 align-middle">{item?.description}</td>
      <td className="py-1 align-middle">{item?.gsm}</td>
      <td className="py-1 align-middle">{item?.color}</td>
      <td className="py-1 align-middle">{item?.availableQty?.toFixed(4)}</td>

      <td className="table-action py-1 align-middle">
        <button
          onClick={(e) => {
            setSearchParams((prev) => {
              delete prev["sort"];
              delete prev["order"];
              delete prev["query"];
              delete prev["material-page"];
              return {
                ...prev,
                tab: "material-purchase",
                "material-page": searchParams.get("material-page") || 1,
                filterBy: "all",
                materialId: item.materialId,
                limit: "10",
              };
            });
          }}
          className="btn-info btn-sm btn"
        >
          Purchases
        </button>
        <button
          onClick={(e) => {
            setSearchParams((prev) => {
              delete prev["sort"];
              delete prev["order"];
              delete prev["query"];
              delete prev["material-page"];
              return {
                ...prev,
                tab: "material-issue",
                page: 1,
                "material-page": searchParams.get("material-page") || 1,
                filterBy: "all",
                materialId: item.materialId,
                limit: "10",
              };
            });
          }}
          className="btn-info btn-sm btn ms-1"
        >
          issues
        </button>

        <button
          disabled={loading}
          onClick={() => {
            handleUpdateData(item);
          }}
          className="btn px-1"
        >
          <i className="mdi mdi-pencil"></i>
        </button>

        {/* <DeleteModalButton
          btnClass={"btn  px-1"}
          deleteFunc={deleteMaterialListData}
          deleteParams={item.id}
          disableConditions={loading}
        /> */}
      </td>
    </tr>
  );

  return (
    <div className="px-3 py-2">
      {loading && <Spinner />}
      {/* Table */}
      <div className="">
        {!advanceSearchResult ? (
          <>
            <div className="">
              <div className="d-flex justify-content-end align-items-center mb-3">
                <div className="flex-grow-1 d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center gap-1">
                    <div>Show</div>
                    <button
                      className="px-1 bg-primary bg-opacity-10 border border-primary rounded-end rounded-start "
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {searchParams.get("limit")}
                    </button>
                    <ul
                      style={{ width: "fit-content" }}
                      className="dropdown-menu"
                    >
                      {limits.map((limit) => (
                        <li key={limit}>
                          <button
                            className="dropdown-item"
                            onClick={() => changeLimit(limit)}
                          >
                            {limit}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="me-1 d-flex align-items-center gap-1">
                    <button
                      onClick={() => setAdvanceSearchModal(true)}
                      className="btn btn-success"
                    >
                      Find
                    </button>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="primary"
                        id="dropdown-basic"
                        className="bg-opacity-10 border border-primary rounded-end rounded-start"
                      >
                        {filterBy.find(
                          (filter) =>
                            filter.value === searchParams.get("filterBy") ||
                            (searchParams.get("filterBy") === null &&
                              filter.value === "all"),
                        )?.name || "Filter By"}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filterBy.map((filter) => (
                          <Dropdown.Item
                            key={filter.value}
                            onClick={() => handleFilterBy(filter.value)}
                          >
                            {filter.name}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>

                <SearchComp
                  setLoading={setLoading}
                  apiPath={`${COMPONENT_URL}${
                    getSearchParamsWithoutGivenKey("query")
                      ? "?" + getSearchParamsWithoutGivenKey("query") + "&"
                      : "?"
                  }`}
                />
                <div>
                  <button
                    onClick={() => {
                      reset();
                      setShowAddModal(true);
                    }}
                    disabled={loading}
                    className="btn btn-primary ms-1"
                  >
                    Add Material
                  </button>
                </div>
              </div>
              <TableOnly
                table_head={table_head}
                table_body={table_body}
                totalPages={totalPages}
                table_data={searchResults ? searchResults : materialListData}
              />

              {loading && <Spinner />}
              {!searchResults && (
                <Pagination
                  totalPages={totalPages}
                  apiPath={`${COMPONENT_URL}${
                    searchParams.toString()
                      ? "?" +
                        getSearchParamsWithoutGivenKey("material-page") +
                        "&"
                      : "?"
                  }material-page=`}
                  currPage={parseInt(searchParams.get("material-page")) || 1}
                />
              )}
            </div>
          </>
        ) : (
          <>
            <Table
              btn1={() => (
                <>
                  <button
                    className="btn btn-danger"
                    onClick={() => setAdvanceSearchResult(null)}
                  >
                    Clear
                  </button>
                  <button
                    onClick={() => setAdvanceSearchModal(true)}
                    className="btn btn-success ms-1"
                  >
                    Find
                  </button>
                </>
              )}
              btnLeft={() => <h4>Advance Search Results</h4>}
              table_head={advanceTableHead}
              table_body={table_body}
              table_data={advanceSearchResult}
            />
          </>
        )}
      </div>
      {/*   Add Modal
       ********************************************* */}
      <Modal show={showAddModal} onHide={() => reset()}>
        <Modal.Body
          className="shadow-lg bg-white px-3 "
          style={{ borderRadius: 15 }}
        >
          <div className="">
            <h4>{isUpdateMode ? "Update Material" : "Add Material"}</h4>
          </div>
          <hr className="mt-0" />
          <form
            onSubmit={
              isUpdateMode
                ? handleUpdateMaterialListData
                : handleMaterialListData
            }
            className=""
          >
            {/* type */}
            <div className="form-group mb-3">
              <label htmlFor="type">Type</label>
              <AutoComplete
                required={true}
                fieldName={"type"}
                placeholder={"Enter Type"}
                searchFunction={searchMaterialList}
                handleChange={handleAutoCompleteChange}
                classNames={"form-control"}
                value={formData.type || ""}
              />
            </div>

            {/* Style Id */}
            <div className="form-group mb-3">
              <label htmlFor="styleId">Style Id</label>
              <AutoComplete
                required={true}
                fieldName={"styleId"}
                searchFunction={searchMaterialList}
                placeholder={"Enter Style Id"}
                handleChange={handleAutoCompleteChange}
                classNames={"form-control"}
                value={formData.styleId || ""}
              />
            </div>

            {/* description */}
            <div className="form-group mb-3">
              <label htmlFor="description">Description</label>
              <AutoComplete
                required={true}
                fieldName={"description"}
                placeholder={"Enter Description"}
                searchFunction={searchMaterialList}
                handleChange={handleAutoCompleteChange}
                classNames={"form-control"}
                value={formData.description || ""}
              />
            </div>

            {/* GSM */}
            <div className="form-group mb-3">
              <label htmlFor="gsm">GSM</label>
              <AutoComplete
                fieldName={"gsm"}
                searchFunction={searchMaterialList}
                placeholder={"Enter Gsm"}
                handleChange={handleAutoCompleteChange}
                classNames={"form-control"}
                value={formData.gsm || ""}
              />
            </div>

            {/* Color */}
            <div className="form-group mb-3">
              <label htmlFor="color">Color</label>
              <AutoComplete
                fieldName={"color"}
                searchFunction={searchMaterialList}
                placeholder={"Enter Color"}
                handleChange={handleAutoCompleteChange}
                classNames={"form-control"}
                value={formData.color || ""}
              />
            </div>

            {/* minQty */}
            <div className="form-group mb-3">
              <label htmlFor="minQty">Min Qty</label>
              <AutoComplete
                is2digitFloat={true}
                searchFunction={searchMaterialList}
                type={"number"}
                fieldName={"minQty"}
                placeholder={"Enter Min Qty"}
                handleChange={handleAutoCompleteChange}
                classNames={"form-control"}
                value={formData.minQty || ""}
              />
            </div>

            {/*   buttons
             ********************************************* */}
            <div className="mt-3">
              <div className="d-flex justify-content-end">
                <button
                  onClick={() => {
                    reset();
                  }}
                  className="btn btn-secondary btn-sm"
                  type="button"
                >
                  Close
                </button>
                <button
                  disabled={loading}
                  className="btn btn-primary btn-sm ms-1"
                  type="submit"
                >
                  {isUpdateMode ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {/*   Advance Customer Search
       ********************************************* */}
      <Modal
        size="lg"
        contentClassName="bg-transparent"
        show={advanceSearchModal}
        onHide={() => setAdvanceSearchModal(false)}
      >
        <Modal.Body
          className="bg-light custom-shadow-sm p-3"
          style={{ borderRadius: 15 }}
        >
          <FindReportAdvanceFormLayout
            showModal={setAdvanceSearchModal}
            setSearchResult={setAdvanceSearchResult}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
